import { toast } from 'sonner';
import { isNil } from 'ramda';

// lang
import { __ } from '@wordpress/i18n';

/**
 * Handle error msg displaying
 *
 * @param {string} msg
 * @param {object} args
 *
 * @returns (void)
 */
const handleErrorAndDisplay = (msg, args = {}) => {
    const config = {
        'className': 'uniSonnerNotifications toastError',
        ...args
    }

    toast.error(isNil(msg) ? __('Error', 'soundbetween') : msg, config);
};

export default handleErrorAndDisplay;